var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-back" }, [
    _c("div", { staticClass: "login-content" }, [
      _c("div", { staticClass: "input-info" }, [
        _c(
          "div",
          {
            staticStyle: {
              "margin-top": "20px",
              "font-size": "30px",
              color: "blue"
            }
          },
          [_vm._v("办公OA系统")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { "margin-top": "20px", "font-size": "25px" } },
          [_vm._v("欢迎登录")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { "margin-top": "50px" } },
          [
            _c(
              "el-input",
              {
                staticStyle: { width: "300px" },
                attrs: { placeholder: "请输入用户名" },
                model: {
                  value: _vm.name,
                  callback: function($$v) {
                    _vm.name = typeof $$v === "string" ? $$v.trim() : $$v
                  },
                  expression: "name"
                }
              },
              [_c("template", { slot: "prepend" }, [_vm._v("账号")])],
              2
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { "margin-top": "30px" } },
          [
            _c(
              "el-input",
              {
                staticStyle: { width: "300px" },
                attrs: { type: "password", placeholder: "请输入密码" },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.submitlogin.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.password,
                  callback: function($$v) {
                    _vm.password = typeof $$v === "string" ? $$v.trim() : $$v
                  },
                  expression: "password"
                }
              },
              [_c("template", { slot: "prepend" }, [_vm._v("密码")])],
              2
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { "margin-top": "50px" } },
          [
            _c(
              "el-button",
              {
                staticStyle: { width: "300px" },
                attrs: { type: "primary" },
                on: { click: _vm.submitlogin }
              },
              [_vm._v("登录")]
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticStyle: {
          color: "#E8E8E8",
          "text-align": "center",
          position: "absolute",
          bottom: "10px",
          margin: "0 auto",
          width: "100%"
        }
      },
      [_c("footer_text")],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10d9df09", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10d9df09","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login.vue
// module id = null
// module chunks = 